import { Table, Tag } from "antd";
import moment from "moment";

const TableSimple = ({ data }) => {
  // Map role slugs to role names
  const roleMap =
    data?.roles?.reduce((acc, role) => {
      acc[role.slug] = role.name;
      return acc;
    }, {}) || {};

  // Combine users and invites into table data
  const tableData = [
    ...(data?.users?.map((user, index) => ({
      key: `user-${index}`,
      name:
        [user.first_name, user.last_name].filter(Boolean).join(" ") || "N/A",
      email: user.email_address || "N/A",
      invited_by: "N/A",
      created: "N/A",
      accepted_at: "N/A",
      roles: user.roles,
      type: "user",
    })) || []),
    ...(data?.invites?.map((invite, index) => ({
      key: `invite-${index}`,
      name:
        [invite.first_name, invite.last_name].filter(Boolean).join(" ") ||
        "N/A",
      email: invite.email_address || "N/A",
      invited_by: invite.invited_by
        ? [invite.invited_by.first_name, invite.invited_by.last_name]
            .filter(Boolean)
            .join(" ") ||
          invite.invited_by.email_address ||
          "N/A"
        : "N/A",
      created: invite.created
        ? moment(invite.created).format("YYYY-MM-DD HH:mm:ss")
        : "N/A",
      accepted_at: invite.accepted_at
        ? moment(invite.accepted_at).format("YYYY-MM-DD HH:mm:ss")
        : "Not Accepted",
      roles: ["Pending"],
      type: "invite",
    })) || []),
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "15%",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "20%",
    },
    {
      title: "Invited By",
      dataIndex: "invited_by",
      key: "invited_by",
      width: "15%",
      responsive: ["md"],
    },
    {
      title: "Created",
      dataIndex: "created",
      key: "created",
      width: "15%",
      responsive: ["lg"],
    },
    {
      title: "Accepted At",
      dataIndex: "accepted_at",
      key: "accepted_at",
      width: "15%",
      responsive: ["lg"],
    },
    {
      title: "Status",
      dataIndex: "roles",
      key: "status",
      width: "10%",
      render: (roles) => (
        <>
          {roles.map((role) => {
            const displayRole =
              role === "Pending" ? "Pending" : roleMap[role] || role;
            let color;
            if (displayRole === "Pending") {
              color = "orange";
            } else if (displayRole === "Admin") {
              color = "geekblue";
            } else if (displayRole === "Master") {
              color = "volcano";
            } else {
              color = "green";
            }
            return (
              <Tag color={color} key={role}>
                {displayRole.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
  ];

  return (
    <div className="table-simple-container">
      <Table
        size="small"
        columns={columns}
        dataSource={tableData}
        pagination={false}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default TableSimple;
